<template>
  <v-layout align-start>
    <template v-if="numeroAsistencia">
      <MiniBitacora
        :numero-asistencia="numeroAsistencia"
        :isShowing="isShowing"
        :disabled="true"
        @update:isShowing="isShowing = $event"
      />
    </template>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="bitacoras"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Bitacora</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  icon
                  color="green"
                  @click="init()"
                  v-bind="attrs"
                  v-on="on"
                  ><v-icon class="fa fa-sync-alt"></v-icon
                ></v-btn>
              </template>
              <span>Mostrar solo las de este día</span>
            </v-tooltip>
            <v-col cols="auto" md="3">
              <v-text-field
                class="text-xs-center ml-5"
                v-model="search"
                append-icon="search"
                label="Busqueda"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" md="2" class="mr-4">
              <v-text-field
                v-model="fechaDesde"
                type="date"
                hide-details
                label="Desde fecha de creación"
                :max="new Date().toISOString().substr(0, 10)"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="auto" md="2" class="mr-4">
              <v-text-field
                v-model="fechaHasta"
                type="date"
                hide-details
                label="Hasta fecha de creación"
                :max="new Date().toISOString().substr(0, 10)"
                clearable
              ></v-text-field>
            </v-col>
            <v-col md="1">
              <v-btn
                color="green"
                :block="$vuetify.breakpoint.smAndDown"
                dark
                :disabled="!fechaDesde || !fechaHasta"
                @click="DescargarInformeBitacoras"
              >
                <v-icon>fas fa-file-download</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" md="1">
              <v-btn @click="listar()" color="blue" dark> Listar </v-btn>
            </v-col>
          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)"> edit </v-icon>
        </template>
        <template v-slot:[`item.seguimiento`]="{ item }">
          {{ mostrarSeguimiento(item) }}
        </template>
      </v-data-table>

      <!-- PreLoader -->
      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          v-if="true"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          background="transparent"
          speed="1"
          style="width: 300px; height: 300px"
          loop
          autoplay
        ></lottie-player>
      </v-overlay>

      <v-snackbar
        v-model="snackFechas"
        color="cyan darken-2"
        top
        right
        :timeout="3000"
        >Debe de seleccionar ambas fechas.</v-snackbar
      >

      <v-snackbar v-model="snackError" color="cyan darken-2" top
        >Sucedio algun error, verificar estado de conexión.</v-snackbar
      >
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import MiniBitacora from "./Minis/MiniBitacora.vue";
import XLSX from "xlsx";

export default {
  components: {
    MiniBitacora,
  },
  data() {
    return {
      informeBitacora: [],
      isShowing: false,
      bitacoras: [],
      headers: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        {
          text: "Numero Asistencia",
          value: "numeroAsistencia",
          sortable: true,
        },
        { text: "Operador", value: "operador", sortable: true },
        {
          text: "Fecha Hora Actual",
          value: "fechaHoraActual",
          sortable: true,
        },
        {
          text: "Direccion Siniestro",
          value: "comDireccionSiniestro",
          sortable: true,
        },
        { text: "Tipo Servicio", value: "tipoServicio", sortable: true },
        { text: "Proveedor", value: "proveedor", sortable: true },
        { text: "Seguimiento", value: "seguimiento", sortable: true },
      ],
      search: "",
      id: "",
      numeroAsistencia: "",
      inicioVigencia: "",
      disabled: false,
      overlay: true,
      snackError: false,
      dateToday: "",
      fechaDesde: null,
      fechaHasta: null,
      snackFechas: false,
    };
  },
  computed: {},
  watch: {},
  created() {
    this.init();
  },
  methods: {
    DescargarInformeBitacoras() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      this.overlay = true;

      axios
        .get(
          `api/DetalleBitacora/InformeDetalleBitacora?inicio=${this.fechaDesde}&fin=${this.fechaHasta}`,
          configuracion
        )
        .then((res) => {
          this.informeBitacora = res.data;

          let data = XLSX.utils.json_to_sheet(this.informeBitacora);
          const workbook = XLSX.utils.book_new();

          XLSX.utils.book_append_sheet(workbook, data, "Bitacoras");

          XLSX.writeFile(
            workbook,
            `Bitacotas ${this.fechaDesde} - ${this.fechaHasta}.xlsx`
          );
        })
        .catch((err) => {
          console.error(err.response);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    init() {
      let me = this;
      var dateFormat = new Date();
      me.dateToday =
        dateFormat.getFullYear() +
        "-" +
        (dateFormat.getMonth() + 1) +
        "-" +
        dateFormat.getDate();
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.bitacoras = [];
      me.overlay = true;
      axios
        .get(
          "api/Bitacoras/Listar/" + me.dateToday + "/" + me.dateToday,
          configuracion
        )
        .then(function (response) {
          me.bitacoras = response.data;
          if (response.status == 200) {
            me.overlay = false;
          }
        })
        .catch(function (error) {
          console.log(error);
          me.snackError = true;
          me.overlay = false;
        });
    },
    listar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      if (me.fechaDesde != null && me.fechaHasta != null) {
        me.bitacoras = [];
        me.overlay = true;
        axios
          .get(
            "api/Bitacoras/Listar/" + me.fechaDesde + "/" + me.fechaHasta,
            configuracion
          )
          .then(function (response) {
            me.bitacoras = [];
            me.bitacoras = response.data;
            me.overlay = false;
          })
          .catch(function (error) {
            console.log("ERROR ", error);
            me.overlay = false;
          });
      } else {
        me.snackFechas = true;
      }
    },
    mostrarSeguimiento(item) {
      if (item.seguimiento) {
        return item.seguimiento;
      } else {
        return item.detalleBitacora
          .map(
            (db) =>
              `${db.detalle} ${db.fechaHora.replace("T", "")} ${db.usuario}`
          )
          .join("~");
      }
    },
    editItem(item) {
      this.numeroAsistencia = item.numeroAsistencia;
      this.isShowing = true;
    },
  },
};
</script>
